import { LogAdapterClass } from './adapters/LogAdapter';
import { Log } from './Log';

/**
 * @example
 * ```
 * class Foo {
 *      @LogChannelDecorator('FooService')
 *      log: LogChannel;
 *
 *      // Auto-discover name of the channel (eg: name will become Foo)
 *      @LogChannelDecorator()
 *      log: LogChannel;
 *
 *      // Log channel with name and adapter
 *      @LogChannelDecorator('FooService', ConsoleAdapter)
 *      log: LogChannel;
 *
 *      foo () {
 *          this.log.info('hi there');
 *      }
 * }
 * ```
 * @param name
 * @param adapter
 * @constructor
 */
export function LogChannelDecorator(name?: string | string[], adapter?: LogAdapterClass): any {
    return (target: any) => ({
        value: Log.channel(name ?? target.name ?? target.constructor.name ?? 'global', adapter),
    });
}
